module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[34]521.53606f1.woff2";